import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Construction Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import City from "./City";
import Image from "./Image";
import Typology from "./Typology";
import Company from "./Company";
import ConstructionContact from "./ConstructionContact";
import ConstructionContactAgent from "./ConstructionContactAgent";
import ContactAgent from "./ContactAgent";
import Contact from "./Contact";
import { take, map, uniq } from 'lodash';
import { i18n } from "../../boot/i18n";
var Construction = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Construction, _VuexORM$Model);
  var _super = _createSuper(Construction);
  function Construction() {
    _classCallCheck(this, Construction);
    return _super.apply(this, arguments);
  }
  _createClass(Construction, [{
    key: "$incrementMapVisits",
    value: function $incrementMapVisits() {
      return Construction.api().put("/api/constructions/".concat(this.id, "/map-visits"));
    }
  }, {
    key: "$incrementPopupVisits",
    value: function $incrementPopupVisits() {
      return Construction.api().put("/api/constructions/".concat(this.id, "/popup-visits"));
    }
  }, {
    key: "$delete",
    value: function $delete(companyId) {
      return Construction.api().delete("/api/companies/".concat(this.company_id, "/constructions/").concat(this.id));
    }
  }, {
    key: "$deleteAttachment",
    value: function $deleteAttachment(attachmentType) {
      return Construction.api().delete("/api/companies/".concat(this.company_id, "/constructions/").concat(this.id, "/delete-attachment/").concat(attachmentType));
    }
  }, {
    key: "$sendMessage",
    value: function $sendMessage(destination, message) {
      return Construction.api().post("/api/companies/".concat(this.company_id, "/constructions/").concat(this.id, "/send-message"), {
        destination: destination,
        message: message
      });
    }
  }, {
    key: "$generateSignPDF",
    value: function $generateSignPDF(format, type) {
      return Vue.prototype.$axios.get("/api/companies/".concat(this.company_id, "/constructions/").concat(this.id, "/sign?format=").concat(format, "&type=").concat(type), {
        headers: {
          Accept: 'application/pdf'
        },
        responseType: 'arraybuffer'
      });
    }
  }, {
    key: "getTypologiesNames",
    value: function getTypologiesNames() {
      var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      var sold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!this.typologies) return '';
      return take(uniq(map(this.typologies, function (typology) {
        if (typology.typology_category) {
          if (typeof sold !== 'boolean' || typology.sold === sold) {
            return typology.typology_category.name;
          }
        }
        return null;
      })).filter(Boolean), count).join(', ');
    }
  }, {
    key: "setTypologiesOrder",
    value: function setTypologiesOrder(typologyIds) {
      return Construction.api().post("/api/companies/".concat(this.company_id, "/constructions/").concat(this.id, "/reorder-typologies"), {
        typology_ids: typologyIds
      });
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'constructions';
    }
  }, {
    key: "fields",
    value:
    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        id: this.attr(null),
        company_id: this.number(0),
        company: this.belongsTo(Company, 'company_id'),
        city_id: this.number(0),
        city: this.belongsTo(City, 'city_id'),
        address: this.attr(''),
        zone: this.attr(''),
        name: this.attr(''),
        zip_code: this.attr(''),
        building_site_number: this.attr(''),
        location: this.attr(''),
        location_verified: this.number(0),
        latitude: this.attr(''),
        longitude: this.attr(''),
        distance: this.attr(''),
        web_code: this.attr(''),
        show_in_home: this.boolean(false),
        owner_contact_id: this.number(null).nullable(),
        owner_contact: this.belongsTo(Contact, 'owner_contact_id'),
        builder_contact_id: this.number(null).nullable(),
        builder_contact: this.belongsTo(Contact, 'builder_contact_id'),
        design_contact_id: this.number(null).nullable(),
        design_contact: this.belongsTo(Contact, 'design_contact_id'),
        description: this.attr(''),
        description_small_pdf: this.attr(''),
        description_medium_pdf: this.attr(''),
        description_large_pdf: this.attr(''),
        fiscal_deduction: this.boolean(false),
        fiscal_deduction_description: this.attr(''),
        announcement_in_progress: this.boolean(false),
        announcement_description: this.attr(''),
        construction_progress: this.attr(''),
        status: this.attr(''),
        construction_start: this.attr(''),
        construction_start_month: this.attr(''),
        construction_start_year: this.attr(''),
        delivery_forecast: this.attr(''),
        delivery_forecast_month: this.attr(''),
        delivery_forecast_year: this.attr(''),
        ready_to_deliver: this.boolean(false),
        three_months_delivery: this.boolean(false),
        tbd_delivery: this.boolean(false),
        energy_class_text: this.attr(''),
        direct_sales: this.boolean(false),
        custom_sales_text: this.attr(''),
        internal_notes: this.attr(''),
        video_url: this.attr(''),
        website: this.attr(''),
        residential: this.attr(''),
        commercial: this.attr(''),
        terrain: this.attr(''),
        from_price: this.attr(''),
        to_price: this.attr(''),
        from_area: this.attr(''),
        to_area: this.attr(''),
        brochure: this.attr(''),
        specifications: this.attr(''),
        datasheet: this.attr(''),
        brochure_url: this.attr(''),
        specifications_url: this.attr(''),
        editable_sign: this.boolean(false),
        datasheet_url: this.attr(''),
        map_visits: this.attr(''),
        visits: this.attr(''),
        popup_visits: this.attr(''),
        qr_clicks: this.attr(''),
        sent_emails: this.attr(''),
        specific_logo_id: this.number(null).nullable(),
        specific_logo: this.belongsTo(Image, 'specific_logo_id'),
        images: this.morphMany(Image, 'imageable_id', 'imageable_type'),
        attachments: this.attr([]),
        typologies: this.hasMany(Typology, 'construction_id'),
        categories: this.attr(''),
        // available only in index
        contacts: this.belongsToMany(Contact, ConstructionContact, 'construction_id', 'contact_id'),
        contact_agents: this.belongsToMany(ContactAgent, ConstructionContactAgent, 'construction_id', 'contact_agent_id'),
        url: this.attr(''),
        previous_construction_link: this.attr(''),
        next_construction_link: this.attr(''),
        imported_data: this.attr({}),
        sign_data: this.attr(null),
        updated_at: this.attr(''),
        created_at: this.attr('')
      };
    }
  }, {
    key: "$getByCode",
    value: function $getByCode(code) {
      var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var preview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var incrementVisits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var incrementQR = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      return Construction.api().get("/api/constructions/".concat(code), {
        params: {
          preview: preview ? 1 : 0,
          increment_visits: incrementVisits ? 1 : 0,
          increment_qr_clicks: incrementQR ? 1 : 0,
          filters: filters
        }
      });
    }
  }]);
  return Construction;
}(VuexORM.Model);
_defineProperty(Construction, "CONSTRUCTION_PROGRESS_OPTIONS", [{
  label: i18n.t('app.buildings.construction_progress_options.design_in_progress'),
  value: 'design_in_progress'
}, {
  label: i18n.t('app.buildings.construction_progress_options.in_construction'),
  value: 'in_construction'
}, {
  label: i18n.t('app.buildings.construction_progress_options.completed'),
  value: 'completed'
}]);
_defineProperty(Construction, "STATUS_OPTIONS", [{
  label: i18n.t('app.buildings.status_options.draft'),
  value: 'draft'
}, {
  label: i18n.t('app.buildings.status_options.in_promotion'),
  value: 'in_promotion'
}, {
  label: i18n.t('app.buildings.status_options.archived'),
  value: 'archived'
}, {
  label: i18n.t('app.buildings.status_options.in_history'),
  value: 'in_history'
}]);
_defineProperty(Construction, "CONSTRUCTION_LOCATION_OPTIONS", [{
  label: i18n.t('app.buildings.positions.approximate'),
  value: 0
}, {
  label: i18n.t('app.buildings.positions.real'),
  value: 1
}]);
export { Construction as default };